/* eslint-disable global-require */
// keep alphabetic order
import { deliveryPriceConfig } from 'config/deliveryPrice'
import * as signup from 'routes/Signup/signupConfig'

import apps from './apps'
import auth from './auth'
import basket from './basket'
import company from './company'
import freeDelivery from './freeDelivery'
import media from './media'
import menu from './menu'
import * as recipes from './recipes'
import routes from './routes'
import template from './template'

// eslint-disable-next-line import/no-default-export
export default {
  apps,
  auth,
  basket,
  company,
  deliveryPriceConfig,
  freeDelivery,
  media,
  menu,
  recipes,
  routes,
  signup,
  template,
}
